import { collectorIds } from '../constants/valueIds'
import { CustomSymbol } from '../CustomSymbol'

/**
 *
 */

/**
 * Filters the collector symbols from the given array of symbols.
 * @param symbols The array of symbols to filter.
 * @returns The filtered array of collector symbols.
 */
export function filterCollectorSymbols(symbols: CustomSymbol[]): CustomSymbol[] {
    const collectorIdSet = new Set(collectorIds)
    return symbols.filter((symbol) => collectorIdSet.has(symbol.id))
}
